module.exports = __webpack_public_path__ + "img/upset.6d52c8a7.svg";